import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import getCountryIds from 'helpers/getCountryIds';
import getRegionBreakdown from 'helpers/getRegionBreakdown';

export default getShortFormVideoKPIUrl;

/**
 * This URL constructor creates an URL for ShortFormVideo.
 * @param {object} args URL constructor arguments
 * @param {array} args.countryIds Array of country id's to retrieve data for, if omitted data should be returned as broken down (split out) to each country separately
 * @param {array} args.entityIds Array of entity id's to retrieve data for
 * @param {('track' | 'artist' | 'album' | 'project')} args.entityType Entity type that supports showing data for ShortFormVideo
 * @returns {string} ShortFormVideo URL for tracks and artists
 */

interface IProps {
  countryIds?: string[];
  entityIds: string[];
  entityType: 'track' | 'artist' | 'album' | 'project';
  metricType?: 'views' | 'creations';
  region?: string;
  compareMode?: string;
  customRegion?: string | string[];
  platform?: number;
  download?: boolean;
}

function getShortFormVideoKPIUrl(args: IProps): string {
  const {
    compareMode,
    countryIds,
    entityIds,
    entityType,
    metricType,
    region,
    customRegion,
    platform,
    download,
  } = args;

  const apiEntityType = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    metricType,
    download,
    customerFilter: platform,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  return `/api/shortFormVideo/kpi/${apiEntityType}/${entityIds}${
    params !== '' ? `?${params}` : ''
  }`;
}
